"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = exports.BaseRoutes = exports.Router = exports.DynamicLoadManualStaticSubappAndSpa = exports.DynamicLoadManualStatic = exports.DynamicLoadManualManager = exports.Microfrontend = void 0;
var Microfrontend_1 = require("./Microfrontend");
Object.defineProperty(exports, "Microfrontend", { enumerable: true, get: function () { return Microfrontend_1.Microfrontend; } });
Object.defineProperty(exports, "DynamicLoadManualManager", { enumerable: true, get: function () { return Microfrontend_1.DynamicLoadManualManager; } });
Object.defineProperty(exports, "DynamicLoadManualStatic", { enumerable: true, get: function () { return Microfrontend_1.DynamicLoadManualStatic; } });
Object.defineProperty(exports, "DynamicLoadManualStaticSubappAndSpa", { enumerable: true, get: function () { return Microfrontend_1.DynamicLoadManualStaticSubappAndSpa; } });
var BaseRoutes_1 = require("./BaseRoutes");
Object.defineProperty(exports, "Router", { enumerable: true, get: function () { return BaseRoutes_1.Router; } });
Object.defineProperty(exports, "BaseRoutes", { enumerable: true, get: function () { return BaseRoutes_1.BaseRoutes; } });
var Routes_1 = require("./Routes");
Object.defineProperty(exports, "Routes", { enumerable: true, get: function () { return Routes_1.Routes; } });
__exportStar(require("./constants"), exports);
//# sourceMappingURL=index.js.map